<template lang="pug">
  v-btn(icon @click.stop='toggleStatus')
    v-icon(v-if="value.published" small) visibility
    v-icon(v-else small) visibility_off
</template>

<script>
import http from '@/http'
export default {
  props: {
    resource: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    busy: false
  }),

  methods: {
    async toggleStatus() {
      if (this.busy) return
      this.busy = true

      try {
        const { published, id } = this.value
        const newStatus = published ? 'unpublish' : 'publish'
        const response = await http.post(`/${this.resource}/${id}/${newStatus}`)
        this.$emit('input', response.data)
        this.$emit('success', response.data)
      } catch (error) {
        this.$root.showSnack('Ошибка обновления статуса')
      } finally {
        this.busy = false
      }
    }
  }
}
</script>
